var appSubdomain = window.appSubdomain;
var appSubdomain;
appSubdomain = function (url) {
  var el, hostname, lastIndex, searchString;
  el = document.createElement('a');
  el.href = url;
  hostname = el.hostname;
  searchString = '.' + $domain;
  lastIndex = hostname.lastIndexOf(searchString);
  return lastIndex > 0 && lastIndex === hostname.length - searchString.length;
};
$.ajaxPrefilter(function (options, originalOptions, xhr) {
  if (!options.crossDomain || appSubdomain(options.url)) {
    return $.rails.CSRFProtection(xhr);
  }
});
window.appSubdomain = appSubdomain;